import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../../utils/immutable";
import { IAction } from "../../../../models/Action";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { compose } from "redux";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  CONFIGURATIONS,
  OFFICES,
  SOCIETIES,
  ORGANIZATIONAL_UNITS,
  ATTRIBUTES,
  COUNTERS,
  USERS_OPERATIONS_CONFIGURATIONS,
  REQUEST_STATE,
  OU_ENRICHMENTS,
  ROLES,
  SELECTED_ROLE,
  BUTTONS,
  FIELD_VISIBILITY,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.ouCode,
          ouCode: data.ouCode,
          ouType: data.ouType,
          ouIdCounter: data.ouIdCounter,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [CONFIGURATIONS, OU_ENRICHMENTS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([CONFIGURATIONS, OU_ENRICHMENTS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_OU_ENRICHMENTS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          code: data.code,
          description: data.description,
          value: data.value,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [CONFIGURATIONS, CONFIGURATIONS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([CONFIGURATIONS, CONFIGURATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_CONFIGURATIONS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.CONFIGURATIONS_OFFICES_REQUEST]: (state: any, action: any) =>
    immutableSet([CONFIGURATIONS, OFFICES, LOADER_IDENTIFIER], true, state),
  [actionTypes.CONFIGURATIONS_OFFICES_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.officeId,
          name: data.officeName,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([CONFIGURATIONS, OFFICES, LIST_IDENTIFIER], mappedResponse),
      immutableSet([CONFIGURATIONS, OFFICES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_OFFICES_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CONFIGURATIONS, OFFICES, LOADER_IDENTIFIER], false, state),

  [actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST]: (state: any, action: any) =>
    immutableSet([CONFIGURATIONS, SOCIETIES, LOADER_IDENTIFIER], true, state),
  [actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.companyId,
          name: data.companyName,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [CONFIGURATIONS, SOCIETIES, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([CONFIGURATIONS, SOCIETIES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_SOCIETIES_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet([CONFIGURATIONS, SOCIETIES, LOADER_IDENTIFIER], false, state),

  [actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER],
      true,
      state
    ),
  [actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    return compose(
      immutableSet(
        [CONFIGURATIONS, ORGANIZATIONAL_UNITS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [CONFIGURATIONS, ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },
  [actionTypes.CONFIGURATIONS_ORGANIZATIONAL_UNITS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, ORGANIZATIONAL_UNITS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST]: (state: any, action: any) =>
    immutableSet([CONFIGURATIONS, ATTRIBUTES, LOADER_IDENTIFIER], true, state),
  [actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.fieldCode,
          fieldCode: data.fieldCode,
          fieldArea: data.fieldArea,
          fieldType: data.fieldType,
          fieldOrder: data.fieldOrder,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [CONFIGURATIONS, ATTRIBUTES, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet([CONFIGURATIONS, ATTRIBUTES, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_ATTRIBUTES_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet([CONFIGURATIONS, ATTRIBUTES, LOADER_IDENTIFIER], false, state),

  [actionTypes.CONFIGURATIONS_COUNTERS_REQUEST]: (state: any, action: any) =>
    immutableSet([CONFIGURATIONS, COUNTERS, LOADER_IDENTIFIER], true, state),
  [actionTypes.CONFIGURATIONS_COUNTERS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          id: data.counterId,
          counterId: data.counterId,
          counterLastId: data.counterLastId,
          counterLength: data.counterLength,
          counterPrefix: data.counterPrefix,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet([CONFIGURATIONS, COUNTERS, LIST_IDENTIFIER], mappedResponse),
      immutableSet([CONFIGURATIONS, COUNTERS, LOADER_IDENTIFIER], false)
    )(state);
  },
  [actionTypes.CONFIGURATIONS_COUNTERS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet([CONFIGURATIONS, COUNTERS, LOADER_IDENTIFIER], false, state),

  [actionTypes.CREATE_OU_ENRICHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_OU_ENRICHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.CREATE_OU_ENRICHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.CREATE_OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_SOCIETY_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_SOCIETY_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.CREATE_SOCIETY_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_ATTRIBUTE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_ATTRIBUTE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.CREATE_ATTRIBUTE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.CREATE_COUNTER_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_COUNTER_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.CREATE_COUNTER_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_OU_ENRICHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_OU_ENRICHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_OU_ENRICHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_SOCIETY_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_SOCIETY_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_SOCIETY_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_ATTRIBUTE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_ATTRIBUTE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_ATTRIBUTE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_COUNTER_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_COUNTER_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_COUNTER_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_CONFIGURATION_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_OU_ENRICHMENT_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_OU_ENRICHMENT_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_OU_ENRICHMENT_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, OU_ENRICHMENTS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_OFFICE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_OFFICE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_OFFICE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, OFFICES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_SOCIETY_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_SOCIETY_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_SOCIETY_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, SOCIETIES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_ATTRIBUTE_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_ATTRIBUTE_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_ATTRIBUTE_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, ATTRIBUTES, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_COUNTER_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_COUNTER_REQUEST_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_COUNTER_REQUEST_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, COUNTERS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.DELETE_CONFIGURATION_REQUEST]: (state: any, action: any) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.DELETE_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.DELETE_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [CONFIGURATIONS, CONFIGURATIONS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        mappedResponse.push(data);
      });
    return compose(
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_CONSOLE_ADMIN_FIELD_VISIBILITY_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.GET_EXTERNAL_PORTAL_ROLES]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, ROLES, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_EXTERNAL_PORTAL_ROLES_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, ROLES, LIST_IDENTIFIER],
        action.payload.roles
      ),
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, ROLES, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_EXTERNAL_PORTAL_ROLES_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, ROLES, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.SELECT_ROLE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, SELECTED_ROLE],
      action.payload,
      state
    ),

  [actionTypes.GET_BUTTONS_BY_ROLE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_BUTTONS_BY_ROLE_SUCCESS]: (state: any, action: any) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        const tempRow: {} = {
          idButton: data.idButton,
          role: data.role,
        };
        mappedResponse.push(tempRow);
      });
    return compose(
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, LIST_IDENTIFIER],
        mappedResponse
      ),
      immutableSet(
        [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, LOADER_IDENTIFIER],
        false
      )
    )(state);
  },

  [actionTypes.GET_BUTTONS_BY_ROLE_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, LOADER_IDENTIFIER],
      false,
      state
    ),

  [actionTypes.MANAGEMENT_BUTTONS_BY_ROLE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.MANAGEMENT_BUTTONS_BY_ROLE_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.MANAGEMENT_BUTTONS_BY_ROLE_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_FIELD_VISIBILITY]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, REQUEST_STATE],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_FIELD_VISIBILITY_SUCCESS]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, REQUEST_STATE],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_FIELD_VISIBILITY_FAILURE]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, FIELD_VISIBILITY, REQUEST_STATE],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.RESET_BUTTONS]: (state: any, action: any) =>
    immutableSet(
      [USERS_OPERATIONS_CONFIGURATIONS, BUTTONS, LIST_IDENTIFIER],
      [],
      state
    ),

  [actionTypes.RESET_STATE_EXTERNAL_PORTAL_MANAGEMENT]: (
    state: any,
    action: any
  ) => emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
